
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4916 7.37141C16.4916 10.1235 14.4577 12.9873 11.7458 15.8348C9.03392 12.9873 7 10.1235 7 7.37141C7 4.61932 9.12477 2.38831 11.7458 2.38831C14.3669 2.38831 16.4916 4.61932 16.4916 7.37141ZM13.3277 7.13418C13.3277 8.00786 12.6194 8.71612 11.7458 8.71612C10.8721 8.71612 10.1638 8.00786 10.1638 7.13418C10.1638 6.2605 10.8721 5.55225 11.7458 5.55225C12.6194 5.55225 13.3277 6.2605 13.3277 7.13418Z"></path><path d="M3 13.4125L4.89972 12.8697L4.35028 10.9467L2.45056 11.4895C1.59195 11.7348 1 12.5195 1 13.4125V20.3576C1 21.6898 2.27786 22.6496 3.55725 22.2784L9.00211 20.6988L15.4278 22.5347C15.8154 22.6455 16.2273 22.6365 16.6097 22.5091L21.6325 20.8348C22.4491 20.5626 23 19.7983 23 18.9374V14.0456C23 12.6805 21.6626 11.7166 20.3675 12.1483L18.3088 12.8345L18.9412 14.7319L21 14.0456V18.9374L15.9773 20.6117L9.55156 18.7758C9.18979 18.6724 8.80621 18.6732 8.44487 18.778L3 20.3576V13.4125Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowMapPunctuationFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
